import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaidIcon from "@mui/icons-material/Paid";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import { formatCurrency, formatNumber } from "./utils";

const useStyles = makeStyles({
  card: {
    backgroundColor: themeColorsDesingSystem.background.main,
    borderRadius: 4,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: `1px solid ${themeColorsDesingSystem.stone.main}`,
    padding: "1.5rem",
    height: "100%",
  },
  title: {
    fontSize: "0.875rem",
    fontWeight: 700,
    color: themeColorsDesingSystem.gray.dark,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    marginBottom: "0.25rem",
  },
  value: {
    fontSize: "1.75rem",
    fontWeight: 400,
    color: themeColorsDesingSystem.text.primary,
    lineHeight: 1.2,
  },
  iconWrapper: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    backgroundColor: themeColorsDesingSystem.primary.main,
    color: themeColorsDesingSystem.background.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(19,41,75,0.25)",
    flexShrink: 0,
  },
});

function SummaryCard({ title, value, icon }) {
  const classes = useStyles();

  return (
    <Box className={classes.card}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.value}>{value ?? "-"}</Typography>
        </Box>
        <Box className={classes.iconWrapper}>{icon}</Box>
      </Box>
    </Box>
  );
}

export default function SummaryCards({ data, isMobile }) {
  const itemSize = isMobile ? 12 : 6;
  const itemSizeMd = isMobile ? 12 : 3;

  return (
    <Grid container spacing={3} style={{ marginBottom: "1.5rem" }}>
      <Grid item xs={itemSize} md={itemSizeMd}>
        <SummaryCard
          title="Total de Vendas"
          value={formatCurrency(data?.totalVendas)}
          icon={<AttachMoneyIcon />}
        />
      </Grid>
      <Grid item xs={itemSize} md={itemSizeMd}>
        <SummaryCard
          title="Total Pago"
          value={formatCurrency(data?.totalPago)}
          icon={<PaidIcon />}
        />
      </Grid>
      <Grid item xs={itemSize} md={itemSizeMd}>
        <SummaryCard
          title="Total de Débitos"
          value={formatCurrency(data?.totalDebitos)}
          icon={<MoneyOffIcon />}
        />
      </Grid>
      <Grid item xs={itemSize} md={itemSizeMd}>
        <SummaryCard
          title="Quantidade de Pedidos"
          value={formatNumber(data?.quantidadePedidos)}
          icon={<ShoppingCartOutlinedIcon />}
        />
      </Grid>
    </Grid>
  );
}
